import { useEffect, useState } from 'react'
export const useBEARER = () => {



    const [userId, setUserId] = useState(null)

    useEffect(() => {
        if (JSON.parse(localStorage.getItem('USER_ID'))) {
            setUserId(JSON.parse(localStorage.getItem('USER_ID')));
        }
    }, [localStorage.getItem('USER_ID')])

    return { userId }
}